module.exports = __webpack_public_path__ + "static/media/linkedin.9a2f91e3.png";